import Page from "webPage/Page";
import {handleProductGallery} from "../util/handleProductGallery";
import ProductFiltersManager from "../util/ProductFiltersManager";
import {handleProductActions} from "../pages/single-product";

Page.register("tax-product_cat", () => {

    let $product_gallery = $('.js-product-gallery');
    if ($product_gallery.length > 0) {
        $product_gallery.each(function () {
            handleProductGallery($(this));
        });
    }

    let $products = $('.js-products');
    if ($products.length > 0) {
        $products.each(function () {
            new ProductFiltersManager($products);
        });
    }

    handleProductActions();

    $('body').on('click', '.js-product', function () {
        let href = $(this).attr('href');
        try {
            dataLayer.push({
                'event': 'product-click',
                'product-url': href,
                'eventCallback': function () {
                    window.location.href = href;
                }
            });
        } catch (e) {
            console.log(e);
            window.location.href = href;
        }
        return false;
    }).on('click', '.js-series', function () {
        let href = $(this).attr('href');
        try {
            dataLayer.push({
                'event': 'series-click',
                'series-url': href,
                'eventCallback': function () {
                    window.location.href = href;
                }
            });
        } catch (e) {
            console.log(e);
            window.location.href = href;
        }
        return false;
    }).on('click', '.js-cobot', function () {
        let href = $(this).attr('href');
        try {
            dataLayer.push({
                'event': 'cobot-product-click',
                'product-url': href,
                'eventCallback': function () {
                    window.location.href = href;
                }
            });
        } catch (e) {
            console.log(e);
            window.location.href = href;
        }
        return false;
    }).on('click', '.js-cobot-series', function () {
        let href = $(this).attr('href');
        try {
            dataLayer.push({
                'event': 'cobot-series-click',
                'series-url': href,
                'eventCallback': function () {
                    window.location.href = href;
                }
            });
        } catch (e) {
            console.log(e);
            window.location.href = href;
        }
        return false;
    });
});


